module.exports = __webpack_public_path__ + "static/media/strongher4.68d953a6.jpg";